import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mon');
import { OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'wiz-page-mon',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mon/view.scss */
/* src/app/page.mon/view.scss: no such file or directory */`],
})
export class PageMonComponent implements OnInit {
    public history: any = [];
    public recording: boolean = false;

    @ViewChild('messages')
    public messageElement: ElementRef;

    @ViewChild('monitor')
    public monitorElement: ElementRef;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async initRecorder() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            this.mediaRecorder = new MediaRecorder(stream);

            this.mediaRecorder.ondataavailable = event => {
                if (event.data && event.data.size > 0) {
                    audioChunks.push(event.data);
                }
            };
        } catch (err) {
            console.error('마이크 접근에 실패했습니다:', err);
        }
    }

    public async onScrollMessage() {
        let scrollElement = this.messageElement.nativeElement;
        scrollElement.scrollTo(0, scrollElement.scrollHeight * 1.2);
    }

    public async ask(question: string) {
        this.history.push({ role: 'user', text: question + "" });
        await this.service.render();
        this.onScrollMessage();

        const iframeEl = this.monitorElement.nativeElement;
        const doc = iframeEl.contentDocument || iframeEl.contentWindow?.document;
        const html = doc.documentElement.outerHTML;

        question = question + "\n\nhtml 화면:\n" + html

        let resp = await wiz.call("resp", { question });
        this.history.push({ role: 'ai', text: resp.data });

        await this.service.render();
        this.onScrollMessage();
    }

    public async startRecord() {
        if (this.recording) return;
        let root = this;
        const UPLOAD_URL = wiz.url("audio");

        this.recording = true;
        await this.service.render();

        let mediaRecorder, audioChunks = [];
        let audioContext, analyserNode, sourceNode, processorNode;
        let silenceStart = null;
        const SILENCE_THRESH = 0.1;
        const SILENCE_TIMEOUT = 5000;

        async function detectSilence(event) {
            const input = event.inputBuffer.getChannelData(0);
            let sum = 0;
            for (let i = 0; i < input.length; i++) {
                sum += input[i] * input[i];
            }
            const rms = Math.sqrt(sum / input.length);
            if (rms > SILENCE_THRESH) {
                silenceStart = null;
            } else {
                if (silenceStart === null) {
                    silenceStart = performance.now();
                } else if (performance.now() - silenceStart > SILENCE_TIMEOUT) {
                    await root.stopRecording();
                }
            }
        }

        async function sendAudioToServer() {
            const blob = new Blob(audioChunks, { type: 'audio/webm' });
            const fd = new FormData();
            fd.append('upload', blob, 'recording.webm');

            try {
                let resp = await root.service.file.upload(UPLOAD_URL, fd, async (percent: number, total: number, position: number) => { });
                let question = resp.data;
                root.recording = false;
                await root.ask(question);
            } catch (err) {
            }
            await root.service.status.hide("loading");
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            // MediaRecorder 세팅
            mediaRecorder = new MediaRecorder(stream);
            mediaRecorder.ondataavailable = e => {
                if (e.data.size > 0) audioChunks.push(e.data);
            };
            mediaRecorder.onstop = sendAudioToServer;

            // Web Audio API 세팅 (무음 감지용)
            audioContext = new AudioContext();
            sourceNode = audioContext.createMediaStreamSource(stream);
            analyserNode = audioContext.createAnalyser();
            processorNode = audioContext.createScriptProcessor(2048, 1, 1);

            sourceNode.connect(analyserNode);
            analyserNode.connect(processorNode);
            processorNode.connect(audioContext.destination);

            processorNode.onaudioprocess = detectSilence;

            // 녹음 시작
            audioChunks = [];
            mediaRecorder.start();

            this.mediaRecorder = mediaRecorder;
            this.processorNode = processorNode;
            this.analyserNode = analyserNode;
            this.sourceNode = sourceNode;
            this.audioContext = audioContext;
        } catch (err) {
            console.error('마이크 접근 실패:', err);
        }
    }

    public async stopRecording() {
        let mediaRecorder = this.mediaRecorder;
        let processorNode = this.processorNode;
        let analyserNode = this.analyserNode;
        let sourceNode = this.sourceNode;
        let audioContext = this.audioContext;

        if (mediaRecorder && mediaRecorder.state === 'recording') {
            mediaRecorder.stop();
            processorNode.disconnect();
            analyserNode.disconnect();
            sourceNode.disconnect();
            audioContext.close();
        }
    }
}

export default PageMonComponent;